<template>
  <div>
    <div class="form-request">

      <template v-if="family_references_local.length < 2">

        <template v-if="!done">           
          <div class="content-tab">
            <p id="title-forms" class="title-step">Compártenos el contacto de algún familiar que pueda contarnos más sobre ti.</p>
          </div>

          <div :class="typeMessage" role="alert" v-if="message != ''">
            {{message}}
          </div>

          <div class="row">
            <div class="col-sm-6">
              <p class="myLabelTabsTabs" >Nombre completo</p>
              <input class="inputRequest" type="text" v-model="family_reference.family_reference_full_name">
            </div>

            <div class="col-sm-6">
              <p class="myLabelTabsTabs" >Edad</p>
              <input class="inputRequest" type="number" v-model="family_reference.family_reference_age" min="0" max="100">
            </div>

            <div class="col-sm-6">
              <p class="myLabelTabsTabs" for="observations">Tipo de relación</p>
              <select class="select-request" v-model="family_reference.family_reference_relationship">
                <option disabled value="">Tipo de relación</option>
                <option v-for="(relation, index) in relationships" :key="index" v-bind:value="relation.id">{{relation.name}}</option>
              </select>                  
            </div>

            <div class="col-sm-6">
              <p class="myLabelTabsTabs" >Teléfono</p>
              <input class="inputRequest" type="text" v-model="family_reference.family_reference_telephone">
            </div>            

            <div class="col-sm-6">
              <p class="myLabelTabsTabs" >Email</p>
              <input class="inputRequest" type="email" v-model="family_reference.family_reference_email">
            </div>      

            <div class="col-sm-6">
              <p class="myLabelTabsTabs" for="observations">Ciudad</p>
              <select class="select-request" v-model="family_reference.family_reference_city_id">
                <option disabled value="">Seleccione una ciudad</option>
                <option v-for="(city, index) in cities" :key="index" v-bind:value="city.id">{{city.name}}</option>
              </select>                          
            </div>                  
          </div>

          <div class="row">
            <div class="col-sm-6">
              <b-button class="button-save button-form-steps" @click.prevent="save">{{textButton}}</b-button>
            </div>      
          </div>          
        </template>

        <div class="content-tab" v-else>
          <p id="title-forms" class="title-step">La información ha sido diligenciada</p>
        </div>

      </template>

      <table class="table table-condensed" id="table-academic-references" v-if="width > 768">
        <thead>
            <tr>
              <th class="header-column-table">Nombre</th>
              <th class="header-column-table">Edad</th>
              <th class="header-column-table">Relación</th>
              <th class="header-column-table">Teléfono</th>
              <th class="header-column-table">Email</th>
              <th class="header-column-table">Ciudad</th>
              <th class="header-column-table" v-if="!done">Editar</th>
              <th class="header-column-table" v-if="!done">Eliminar</th>
            </tr>
        </thead>
        <tbody>
          <tr v-for="family_reference_iterator in family_references_local" :key="family_reference_iterator.id">
            <td class="myLabelTabs">{{family_reference_iterator.family_reference_full_name}}</td>
            <td class="myLabelTabs">{{family_reference_iterator.family_reference_age }}</td>
            <td class="myLabelTabs">{{family_reference_iterator.family_reference_relationship }}</td>
            <td class="myLabelTabs">{{family_reference_iterator.family_reference_telephone}}</td>
            <td class="myLabelTabs">{{family_reference_iterator.family_reference_email}}</td>
            <td class="myLabelTabs">{{family_reference_iterator.family_reference_city_id}}</td>
            <td v-if="!done">
              <button @click.prevent="edit(family_reference_iterator)" type="button" class="mybuttonAction"><i class="far fa-edit"></i></button>
            </td>            
            <td v-if="!done">
              <button @click.prevent="deleteLaboralReference(family_reference_iterator)" type="button" class="mybuttonAction"><i class="far fa-trash-alt"></i></button>
            </td>            
          </tr>
        </tbody>
      </table>      
      <ul class="list-group" v-else v-for="family_reference_iterator in family_references_local" :key="family_reference_iterator.id">
        <li class="list-group-item active header-list">
          {{family_reference_iterator.family_reference_full_name}}
        </li>
        <li class="list-group-item item-list">Edad: {{family_reference_iterator.family_reference_age}}</li>
        <li class="list-group-item item-list">Relación: {{family_reference_iterator.family_reference_relationship}}</li>
        <li class="list-group-item item-list">Teléfono: {{family_reference_iterator.family_reference_telephone}}</li>
        <li class="list-group-item item-list">Email: {{family_reference_iterator.family_reference_email}}</li>
        <li class="list-group-item item-list">Ciudad: {{family_reference_iterator.family_reference_city_id}}</li>
        <li class="list-group-item item-list" v-if="!done">
          <div class="btn-group" role="group" aria-label="Basic example">
            <button @click.prevent="edit(family_reference_iterator)" type="button" class="button-save"><i class="far fa-edit"></i>Editar</button>
            <button @click.prevent="deleteLaboralReference(family_reference_iterator)" type="button" class="button-save"><i class="far fa-trash-alt"></i>Eliminar</button>              
          </div>            
        </li>
      </ul>        
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { eventBus } from './../../../application'
export default {
  name: "AcademicForm",
  props: ['project', 'assignments', 'cities', 'family_references'],
  data() {
    return {
      width: null,
      typeMessage: '',
      message: '',
      family_references_local: this.family_references,
      family_reference: {},
      textButton: 'Agregar',
      relationships:[
        {id:0, name:'Hermano/a'},
        {id:1, name:'Hijo/a'},
        {id:2, name:'Padre/Madre'},
        {id:3, name:'Tio/a'},
        {id:4, name:'Abuelo/a'},
        {id:5, name:'Primo/a'},
        {id:6, name:'Sobrino/a'},
        {id:7, name:'Amigo/a'},
        {id:8, name:'Esposo/a'},
        {id:9, name:'Suegra/o'},
        {id:10, name:'Cuñado/a'},
        {id:11, name:'Otro'},
      ],
      assignment_types: [11],
      done: false            
    };
  },
  methods: {
    setHeaders () {
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      axios.defaults.headers["x-csrf-token"] = token
      axios.defaults.headers.common["Accept"] = "application/json"
      axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
    },
    getNameCity(city_id) {
      let city = this.cities.find( city => city.id == city_id)
      if (city != null) {
        return city.name
      } else {
        return ''
      }      
    },
    async save() {
      this.family_reference.project_id = this.project.id
      this.setHeaders()
      if (this.family_reference.id != null) { // put
        let request = await axios.put(`/api/v1/update_family_references_origin_candidate/${this.family_reference.id}?token=${this.token}`, { family_reference: this.family_reference })
        if (request.status == 200) {
          this.showMessage('Referencia familiar editada con exito', 'alert-success')
          this.family_reference = {}
        } else {
          this.showMessage('No se pudo editar la referencia familiar', 'alert-danger')
        }
      } else { // post
        let request = await axios.post(`/api/v1/create_family_references_origin_candidate?token=${this.token}`, { family_reference: this.family_reference })
        if (request.status == 201) {
          this.showMessage('Referencia familiar creada con exito', 'alert-success')
          this.family_references_local.push(request.data)
          this.family_reference = {}

        } else {
          this.showMessage('No se pudo crear la referencia familiar', 'alert-danger')
        }
      }
    },
    async deleteLaboralReference (family_reference) {
      const url = `/api/v1/delete_family_references_origin_candidate/${family_reference.id}?token=${this.token}`
      this.setHeaders()
      let request = await axios.delete(url)
      if (request.status == 200) {
        this.family_references_local = this.family_references_local.filter( family_reference_iterator => family_reference_iterator.id != family_reference.id )
        this.showMessage('Referencia familiar eliminada con exito', 'alert-success')
      } else {
        this.showMessage('No se pudo eliminar la referencia familiar', 'alert-danger')
      }
    },
    edit (family_reference) {
      this.family_reference = family_reference
    },
    showMessage(message, typeMessage){
      this.message = message
      this.typeMessage = `alert ${typeMessage}`
      setTimeout(() => this.message = '', 3000)
    },
    setTextButton(){
      if (this.family_reference.id != null){
        this.textButton = 'Editar'
      } else {
        this.textButton = 'Agregar'
      }
    }    
  },
  watch: {
    family_reference() {
      this.setTextButton()
    }
  },  
  created () {
    let token = window.location.search.split('token=')[1]
    if (token != null) {
      this.token = token
    }
    eventBus.$on('authorizeNextTabFamily', dataPassed => {
      if (this.family_references_local.length >= 1) {
        eventBus.$emit('goToNextTab')
      } else {
        this.showMessage('Debe ingresar mínimo una referencia', 'alert-warning')
      }
    })    
  },
  mounted () {
    this.assignment_types.forEach(assignment_type_id => {
      let assignment = this.assignments.filter( assignment => assignment.assignment_type_id == assignment_type_id )[0]
      if (assignment != null) {
        if (assignment.status == 4) {
          this.done = true
        } 
        return
      }
    });                
    this.width = screen.width
  },
};
</script>

<style></style>
